import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MailSignatureCloudSettings" */ './lazyIndex')
);

export const lazyInitMailSignatureCloudSettings = new LazyAction(
    lazyModule,
    m => m.initMailSignatureCloudSettings
);

export { MailSignatureCloudSettings } from './store/schema/MailSignatureCloudSettings';
export { isMailSignatureCloudSettingsInitialized } from './utils/isMailSignatureCloudSettingsInitialized';
export { getEffectiveRoamingNewSignature } from './selectors/getEffectiveRoamingNewSignature';
export { getEffectiveRoamingReplySignature } from './selectors/getEffectiveRoamingReplySignature';
